export default "__VITE_ASSET__Cbj7uwau__"